import React, { useEffect } from 'react';

function SimplePostcodeLookup({ onAddressSelect }) {
  useEffect(() => {
    // Simple initialization matching their docs exactly
    if (window.getAddress && window.getAddress.find) {
      window.getAddress.find('postcode_field', 'zhVROmmlU02K2s0OTJ_Gnw51462');
      
      // Watch for changes to output fields
      const checkForAddress = setInterval(() => {
        const line1 = document.getElementById('address_line_1')?.value;
        const line2 = document.getElementById('address_line_2')?.value;
        const city = document.getElementById('address_city')?.value;
        const county = document.getElementById('address_county')?.value;
        const postcode = document.getElementById('address_postcode')?.value;
        
        if (line1 && city && postcode) {
          const address = [line1, line2].filter(Boolean).join(', ');
          onAddressSelect({ address, city, county, postcode });
          clearInterval(checkForAddress);
        }
      }, 500);
      
      return () => clearInterval(checkForAddress);
    }
  }, [onAddressSelect]);

  return (
    <div>
      <input 
        id="postcode_field"
        type="text"
        placeholder="Enter postcode..."
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
      <p className="mt-1 text-xs text-gray-500">Type postcode to see addresses</p>
      
      {/* Hidden output fields */}
      <div style={{display: 'none'}}>
        <input id="address_line_1" />
        <input id="address_line_2" />
        <input id="address_city" />
        <input id="address_county" />
        <input id="address_postcode" />
      </div>
    </div>
  );
}

export default SimplePostcodeLookup;
